import Loader from 'core/components/common/Loader'
import { CustomToastContainer } from 'core/components/common/Toast'
import { LayoutHeader } from 'core/components/layout/LayoutHeader'
import { DarkModeProvider } from 'core/contexts/DarkThemeContext'
import { UserContext } from 'core/contexts/UserContext'
import React, { ReactNode, useContext } from 'react'

interface LayoutWrapperProps {
  children: ReactNode
  layoutClassName?: string
  displayProfileIcone?: boolean
}

export const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
  children,
  layoutClassName = 'layout-container',
  displayProfileIcone = false,
}) => {
  const { businessStatus } = useContext(UserContext)

  const isBusinessLoading =
    businessStatus === 'idle' || businessStatus === 'loading'

  return (
    <DarkModeProvider>
      <div className={layoutClassName}>
        {isBusinessLoading ? (
          <div className="w-full h-full flex items-center justify-center">
            <Loader pageCenter />
          </div>
        ) : (
          <>
            <LayoutHeader displayProfileIcone={displayProfileIcone} />
            {children}
          </>
        )}
        <CustomToastContainer />
      </div>
    </DarkModeProvider>
  )
}
